import React from 'react';
import { Box } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';

import { ServiceZoneReport } from 'pdfs';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';
import { buildingMock, buildingSummaryMock, serviceDateMock, serviceZonesMock } from 'pdfs/mock';

export const PdfViewPage = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(
      updateLayout({
        headerTitle: 'Reporting',
      }),
    );
  }, []);

  return (
    <Box sx={{ padding: 3 }}>
      <PDFViewer style={{ width: '100%', height: 800 }}>
        <ServiceZoneReport
          building={buildingMock}
          serviceDate={serviceDateMock}
          buildingSummary={buildingSummaryMock}
          zones={serviceZonesMock}
        />
      </PDFViewer>
    </Box>
  );
};
